// language=GraphQL
export const ALL_PERSONAL_DISCOUNTS_QUERY = `query Query($withMandatorySettings: Boolean = false, $withMandatorySettingsRules: Boolean = false, $withMandatorySettingsRulesAccommodations: Boolean = false, $withMandatorySettingsRulesFamilyPackages: Boolean = false, $withMandatorySettingsRulesAccommodationAddons: Boolean = false, $withMandatorySettingsRulesAgeGroups: Boolean = false, $withMandatorySettingsRulesAgeFilter: Boolean = false, $withMandatorySettingsRulesTravelDates: Boolean = false, $withMandatorySettingsDateSwitchSettings: Boolean = false, $withMandatorySettingsBusSettings: Boolean = false) {
  personalDiscounts: ratioPersonalDiscounts {
    id
    ratioServiceNo
    name
    label
    info
    mandatorySettings @include(if: $withMandatorySettings) {
      id
      isMandatory
      useRules
      rules @include(if: $withMandatorySettingsRules) {
        id
        checkAccommodationTypes
        accommodations @include(if: $withMandatorySettingsRulesAccommodations) {
          id
          ratioPackageNo
          name
          label
          info
          isFamilyPackageAccommodation
          isBabyPackage
        }
        familyPackages @include(if: $withMandatorySettingsRulesFamilyPackages) {
          id
          ratioServiceNo
          name
          label
          info
        }
        checkAccommodationAddons
        accommodationAddons @include(if: $withMandatorySettingsRulesAccommodationAddons) {
          id
          ratioServiceNo
          name
          label
          info
        }
        checkAgeGroups
        ageGroups @include(if: $withMandatorySettingsRulesAgeGroups) {
          id
          name
          type
          icon
          minAge
          maxAge
        }
        useAgeFilter
        ageFilter @include(if: $withMandatorySettingsRulesAgeFilter) {
          id
          minAge
          maxAge
        }
        checkDateRange
        startDate
        endDate
        checkTravelDate
        travelDates @include(if: $withMandatorySettingsRulesTravelDates) {
          id
          dateNo
          startDate
          endDate
          isHidden
          includesExtension
          json
        }
      }
      useDateSwitch
      dateSwitchSettings @include(if: $withMandatorySettingsDateSwitchSettings) {
        id
        startDateOffsetDays
        endDateOffsetDays
      }
      useBusSettings
      busSettings @include(if: $withMandatorySettingsBusSettings) {
        id
        boardingSelectionEnabled
      }
    }
  }
}`

// language=GraphQL
export const SINGLE_PERSONAL_DISCOUNT_QUERY = `query Query($id: ID!, $withMandatorySettings: Boolean = false, $withMandatorySettingsRules: Boolean = false, $withMandatorySettingsRulesAccommodations: Boolean = false, $withMandatorySettingsRulesFamilyPackages: Boolean = false, $withMandatorySettingsRulesAccommodationAddons: Boolean = false, $withMandatorySettingsRulesAgeGroups: Boolean = false, $withMandatorySettingsRulesAgeFilter: Boolean = false, $withMandatorySettingsRulesTravelDates: Boolean = false, $withMandatorySettingsDateSwitchSettings: Boolean = false, $withMandatorySettingsBusSettings: Boolean = false) {
  personalDiscount: ratioPersonalDiscount(id: $id) {
    id
    ratioServiceNo
    name
    label
    info
    mandatorySettings @include(if: $withMandatorySettings) {
      id
      isMandatory
      useRules
      rules @include(if: $withMandatorySettingsRules) {
        id
        checkAccommodationTypes
        accommodations @include(if: $withMandatorySettingsRulesAccommodations) {
          id
          ratioPackageNo
          name
          label
          info
          isFamilyPackageAccommodation
          isBabyPackage
        }
        familyPackages @include(if: $withMandatorySettingsRulesFamilyPackages) {
          id
          ratioServiceNo
          name
          label
          info
        }
        checkAccommodationAddons
        accommodationAddons @include(if: $withMandatorySettingsRulesAccommodationAddons) {
          id
          ratioServiceNo
          name
          label
          info
        }
        checkAgeGroups
        ageGroups @include(if: $withMandatorySettingsRulesAgeGroups) {
          id
          name
          type
          icon
          minAge
          maxAge
        }
        useAgeFilter
        ageFilter @include(if: $withMandatorySettingsRulesAgeFilter) {
          id
          minAge
          maxAge
        }
        checkDateRange
        startDate
        endDate
        checkTravelDate
        travelDates @include(if: $withMandatorySettingsRulesTravelDates) {
          id
          dateNo
          startDate
          endDate
          isHidden
          includesExtension
          json
        }
      }
      useDateSwitch
      dateSwitchSettings @include(if: $withMandatorySettingsDateSwitchSettings) {
        id
        startDateOffsetDays
        endDateOffsetDays
      }
      useBusSettings
      busSettings @include(if: $withMandatorySettingsBusSettings) {
        id
        boardingSelectionEnabled
      }
    }
  }
}`

// language=GraphQL
export const CREATE_PERSONAL_DISCOUNT_MUTATION = `
  mutation Mutation($input: CreateRatioPersonalDiscountInput, $withMandatorySettings: Boolean = false, $withMandatorySettingsRules: Boolean = false, $withMandatorySettingsRulesAccommodations: Boolean = false, $withMandatorySettingsRulesFamilyPackages: Boolean = false, $withMandatorySettingsRulesAccommodationAddons: Boolean = false, $withMandatorySettingsRulesAgeGroups: Boolean = false, $withMandatorySettingsRulesAgeFilter: Boolean = false, $withMandatorySettingsRulesTravelDates: Boolean = false, $withMandatorySettingsDateSwitchSettings: Boolean = false, $withMandatorySettingsBusSettings: Boolean = false) {
    personalDiscount: createRatioPersonalDiscount(input: $input) {
      id
      ratioServiceNo
      name
      label
      info
      mandatorySettings @include(if: $withMandatorySettings) {
        id
        isMandatory
        useRules
        rules @include(if: $withMandatorySettingsRules) {
          id
          checkAccommodationTypes
          accommodations @include(if: $withMandatorySettingsRulesAccommodations) {
            id
            ratioPackageNo
            name
            label
            info
            isFamilyPackageAccommodation
            isBabyPackage
          }
          familyPackages @include(if: $withMandatorySettingsRulesFamilyPackages) {
            id
            ratioServiceNo
            name
            label
            info
          }
          checkAccommodationAddons
          accommodationAddons @include(if: $withMandatorySettingsRulesAccommodationAddons) {
            id
            ratioServiceNo
            name
            label
            info
          }
          checkAgeGroups
          ageGroups @include(if: $withMandatorySettingsRulesAgeGroups) {
            id
            name
            type
            icon
            minAge
            maxAge
          }
          useAgeFilter
          ageFilter @include(if: $withMandatorySettingsRulesAgeFilter) {
            id
            minAge
            maxAge
          }
          checkDateRange
          startDate
          endDate
          checkTravelDate
          travelDates @include(if: $withMandatorySettingsRulesTravelDates) {
            id
            dateNo
            startDate
            endDate
            isHidden
            includesExtension
            json
          }
        }
        useDateSwitch
        dateSwitchSettings @include(if: $withMandatorySettingsDateSwitchSettings) {
          id
          startDateOffsetDays
          endDateOffsetDays
        }
        useBusSettings
        busSettings @include(if: $withMandatorySettingsBusSettings) {
          id
          boardingSelectionEnabled
        }
      }
    }
  }`

// language=GraphQL
export const UPDATE_PERSONAL_DISCOUNT_MUTATION = `
  mutation Mutation($input: UpdateRatioPersonalDiscountInput, $withMandatorySettings: Boolean = false, $withMandatorySettingsRules: Boolean = false, $withMandatorySettingsRulesAccommodations: Boolean = false, $withMandatorySettingsRulesFamilyPackages: Boolean = false, $withMandatorySettingsRulesAccommodationAddons: Boolean = false, $withMandatorySettingsRulesAgeGroups: Boolean = false, $withMandatorySettingsRulesAgeFilter: Boolean = false, $withMandatorySettingsRulesTravelDates: Boolean = false, $withMandatorySettingsDateSwitchSettings: Boolean = false, $withMandatorySettingsBusSettings: Boolean = false) {
    personalDiscount: updateRatioPersonalDiscount(input: $input) {
      id
      ratioServiceNo
      name
      label
      info
      mandatorySettings @include(if: $withMandatorySettings) {
        id
        isMandatory
        useRules
        rules @include(if: $withMandatorySettingsRules) {
          id
          checkAccommodationTypes
          accommodations @include(if: $withMandatorySettingsRulesAccommodations) {
            id
            ratioPackageNo
            name
            label
            info
            isFamilyPackageAccommodation
            isBabyPackage
          }
          familyPackages @include(if: $withMandatorySettingsRulesFamilyPackages) {
            id
            ratioServiceNo
            name
            label
            info
          }
          checkAccommodationAddons
          accommodationAddons @include(if: $withMandatorySettingsRulesAccommodationAddons) {
            id
            ratioServiceNo
            name
            label
            info
          }
          checkAgeGroups
          ageGroups @include(if: $withMandatorySettingsRulesAgeGroups) {
            id
            name
            type
            icon
            minAge
            maxAge
          }
          useAgeFilter
          ageFilter @include(if: $withMandatorySettingsRulesAgeFilter) {
            id
            minAge
            maxAge
          }
          checkDateRange
          startDate
          endDate
          checkTravelDate
          travelDates @include(if: $withMandatorySettingsRulesTravelDates) {
            id
            dateNo
            startDate
            endDate
            isHidden
            includesExtension
            json
          }
        }
        useDateSwitch
        dateSwitchSettings @include(if: $withMandatorySettingsDateSwitchSettings) {
          id
          startDateOffsetDays
          endDateOffsetDays
        }
        useBusSettings
        busSettings @include(if: $withMandatorySettingsBusSettings) {
          id
          boardingSelectionEnabled
        }
      }
    }
  }`

// language=GraphQL
export const DELETE_PERSONAL_DISCOUNT_MUTATION = `
  mutation Mutation($input: DeleteRatioPersonalDiscountInput) {
    deleteRatioPersonalDiscount(input: $input) {
      success
    }
  }`

// language=GraphQL
export const FORCE_DELETE_PERSONAL_DISCOUNT_MUTATION = `
  mutation Mutation($input: DeleteRatioPersonalDiscountInput) {
    forceDeleteRatioPersonalDiscount(input: $input) {
      success
    }
  }`
// language=GraphQL
export const PERSONAL_DISCOUNTS_DEPENDENTS_QUERY = `query Query($id: ID!, $withRatioTravels: Boolean = false) {
  groupedDependents: ratioPersonalDiscountDependents(id: $id) {
    ratioTravels @include(if: $withRatioTravels) {
      id
      catalogCode
      travelCode
      destination
      name
      transportType
      transportTypeLabel
      importDateTime
      importStatus
      suppressBusBoardingSelection    }
  }
}`
